<template>
    <div class="gradient uk-padding uk-padding-remove-top">   
        <slot></slot>
        <div class="uk-text-center btn-extra-large-text">
          <div class="newfont" v-html="html_text"></div>
          <div class="nav-flex">
            <button 
              v-if="showBack" 
              class="button-std newfont" 
              @click="backstep"><span class="material-icons">chevron_left</span>Back</button>
            <button 
              v-if="showNext" 
              @click="nextstep" 
              class="button-std newfont">Next<span class="material-icons">chevron_right</span>
            </button>
            <button v-if="showExit" 
              @click="Exit" 
              class="newfont">{{exitText}}</button>
          </div>
        </div>
    </div>
</template>

<script>
export default {
  name:"HtmlDisplay",
  props: {
      html_text: {
          type: String,
          default: "this is the title"
      },
      frameNum:{
          type: Number,
          default: 0
      },
      nextFrame:{
          type: Function
      },
      previousFrame: {
          type: Function
      },
      showNext: {
        type: Boolean,
        default: true
      },
      showBack: {
        type: Boolean,
        default: true
      },
      showExit: {
        type: Boolean,
        default: false
      },
      exitText:{
        type: String,
        default:"Exit"
      },
      for:{
        type:String
      },
      goto:{
        type:Number
      },
      backto:{
        type:Number
      },
  },
  methods: {
      Exit(){
        this.$emit('exit');
      },
      eventpayload(){
        return {
          for:this.for, 
          stepVal:this.goto, 
        }
      },
      nextstep(){
        let Event = this.eventpayload();
        //console.log(Event);
        this.$emit('nextstep', Event)
      },
      backstep(){
        this.$emit('backstep', {for:this.for, stepVal:this.backto})
      },
      confirmNull(){
        this.showConfirmPrompt = true;
      }
  }
}
</script>

<style>
.gradient {
        background: white;
}
.newfont {
  font-family:'Varela Round';
}
.button-std {
  background-color:#325DFF;
  color:#fff;
  font-weight:600;
  padding: 10px 20px;
  border-radius:9px;
  cursor:pointer;
  display:flex;
  align-items:center;
  cursor:pointer;
}
.newfont {
  font-family:'Varela Round';
}

.nav-flex {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items:center;
}
</style>
